import { useTranslation } from 'react-i18next';

const TranslatorService = ({ path }) => {
  const { t } = useTranslation();
  return t(path);
}

export default TranslatorService;